import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CKEditorModule } from 'ng2-ckeditor';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxPaginationModule } from 'ngx-pagination';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';


import { ServiceProvidersRoutingModule } from './service-providers-routing.module';
import { ServiceProvidersComponent } from './service-providers.component';
import { PendingServiceProvidersListComponent } from './pending-service-providers-list/pending-service-providers-list.component';
import { ApprovedServiceProvidersListComponent } from './approved-service-providers-list/approved-service-providers-list.component';
import { DeclinedServiceProvidersListComponent } from './declined-service-providers-list/declined-service-providers-list.component';
import { TechnicianCoverageModalComponent } from './technician-coverage-modal/technician-coverage-modal.component';
import { GeneralServiceProviderComponent } from './parent-service-provider/general-service-provider/general-service-provider.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ServiceProviderTableComponent } from './component/service-provider-table/service-provider-table.component';
import { TechnicianListingComponent } from './component/technician-listing/technician-listing.component';
import { TechnicianTableComponent } from './component/technician-listing/technician-table/technician-table.component';

@NgModule({
  declarations: [
    ServiceProvidersComponent,
    PendingServiceProvidersListComponent,
    ApprovedServiceProvidersListComponent,
    DeclinedServiceProvidersListComponent,
    TechnicianCoverageModalComponent,
    GeneralServiceProviderComponent,
    ServiceProviderTableComponent,
    TechnicianListingComponent,
    TechnicianTableComponent
  ],
  imports: [
    CommonModule,
    ServiceProvidersRoutingModule,
    FurySharedModule,
    ListModule,
    FlexLayoutModule,
    CKEditorModule,
    MatIconModule,
    MatPaginatorModule,
    SharedModule,
    MatTableModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxPaginationModule,
    MatSelectModule,
    MatDialogModule,
    NgxMaskModule,
    MatTabsModule
  ]
})
export class ServiceProvidersModule { }
